import { transformAudio } from '@/scenarios/legacy-player/components/movie-player/transformers/transform-audio';

import { getNotNullableItems } from '../../../lib/get-not-nullable-items';

import { useCurrentTrailerStream } from './use-current-trailer-stream';

export const useTrailerAudio = (contentId: string) => {
    const stream = useCurrentTrailerStream(contentId);

    const audio = getNotNullableItems(stream?.streamMeta?.audioMetas);

    return transformAudio(audio);
};
